import { TransformConvertorBase } from './transform.convertor';
import { Transformation } from 'app/model/dataflow/transformation';
import { DataFlowExpressionUtils } from 'app/model/adapters/dataflow/expression.util';
import { Owned } from 'app/model/base/named';
import { ConditionExpression, ConditionExpressionType } from 'app/model/dataflow/condition-expression';
import {
    BaseMultiInputStreamTransformation,
    BroadcastType
} from 'app/model/dataflow/base-multi-input-stream-transformation';
import { MultiInputStreamBasePlainObject } from 'worker/app-workers/shared/plainObjects/multiInputStreamBase.plainObject';
import { IResourceContext } from 'shell-models-lib';

export abstract class MultiInputsTransformConvertor extends TransformConvertorBase {
    private get transformBase(): BaseMultiInputStreamTransformation {
        return this.transformation as BaseMultiInputStreamTransformation;
    }

    private get objectBase(): MultiInputStreamBasePlainObject {
        return this.transformObject as MultiInputStreamBasePlainObject;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);

        this.objectBase.conditionExpressions.forEach((condition) => {
            const conditionExpression = Owned.create<ConditionExpression>(
                ConditionExpression.MODEL,
                this.transformBase
            );
            conditionExpression.leftExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                condition.leftExpression
            );
            conditionExpression.rightExpression.expression = DataFlowExpressionUtils.unwrapExpressionWithEmptyValue(
                condition.rightExpression
            );
            conditionExpression.conditionType = condition.conditionType as ConditionExpressionType;
            if (conditionExpression.isNonEqualityCondition) {
                this.transformBase.hasNonEqualityConditionExpression = true;
            }
            this.transformBase.conditionExpressions.push(conditionExpression);
        });

        if (this.objectBase.configs.has('broadcast')) {
            const broadcastOption: string = DataFlowExpressionUtils.extractStringConfigValue(
                this.objectBase.configs.get('broadcast')
            );
            this._handledConfigs.push('broadcast');

            this.transformBase.broadcastType = BroadcastType.FIXED;
            switch (broadcastOption) {
                case 'both':
                    this.transformBase.broadcastLeftStream = true;
                    this.transformBase.broadcastRightStream = true;
                    break;
                case 'left':
                    this.transformBase.broadcastLeftStream = true;
                    break;
                case 'right':
                    this.transformBase.broadcastRightStream = true;
                    break;
                case 'off':
                    this.transformBase.broadcastType = BroadcastType.OFF;
                    break;
                default:
                    this.transformBase.broadcastType = BroadcastType.AUTO;
                    break;
            }
        } else {
            this.transformBase.broadcastType = BroadcastType.AUTO;
        }

        super.postConvert();
        return this.transformation;
    }
}
